export default "__VITE_ASSET__CM$RKe64__"